import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'common-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss']
})
export class CommonNewsComponent implements OnInit {

    constructor(@Inject(DOCUMENT) public document: Document) {
    }

    ngOnInit(): void {
    }
}
